import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout/Components/Layout';
import ErrorPage from './ErrorPage';
import PhysicianSearch from './PhysicianSearch/Components/PhysicianSearch';
import { appInsights } from './Services/AppInsights';
import { abpnClient } from './Services/AbpnClient';

function App() {
  const baseName = '/verifycert'
  appInsights.load();
  abpnClient.setErrorPage(`${baseName}/error`);

  return (
    <BrowserRouter basename={baseName}>
    <Layout>
      <Routes>
        <Route path='/error' element={<ErrorPage />} />
        <Route path='/' element={<PhysicianSearch />}></Route>
      </Routes>
    </Layout>
    </BrowserRouter>
  );
}

export default App;
